import React, { useState } from 'react';

const List = ({ people, setPeople }) => {
  const removePerson = (id) => {
    const newPeople = people.filter((person) => person.id !== id);
    setPeople(newPeople);
  };
  return (
    <ul className='persons'>
      {people.map((person) => {
        const { id, name, age, image } = person;
        return (
          <li key={id}>
            <div className='remove-person' onClick={() => removePerson(id)}>
              REMOVE
            </div>
            <img src={image} alt={name} />
            <h2>{name}</h2>
            <p>{age} years</p>
          </li>
        );
      })}
    </ul>
  );
};

export default List;
